import { readLocalStorage, writeLocalStorage } from '../../local-storage'

function toStorageKey(callId: number): string {
  return `editor-track-changes:${callId}`
}

export function readTrackChangesEnabled(callId: number): boolean {
  return readLocalStorage(toStorageKey(callId)) === 'true'
}

export function writeTrackChangesEnabled(callId: number, enabled: boolean) {
  writeLocalStorage(toStorageKey(callId), enabled ? 'true' : 'false')
}
